// Translates UI filters → business queries
import { DEFAULT_LISTS } from '../utils/Constants';
class FilterService {
    static filterByList(tasks, listName) {
        let filteredList;
        if (listName === DEFAULT_LISTS.COMPLETED.title) {
            filteredList = tasks.filter((task) => task.lists.includes(listName));
        }
        else {
            filteredList = tasks.filter((task) => task.lists.includes(listName) &&
                !task.lists.includes(DEFAULT_LISTS.COMPLETED.title));
        }
        return filteredList;
    }
    static defineCustomList(task, customListsArr = []) {
        const taskListArr = task.lists;
        const customListTitles = customListsArr.map((item) => item.title);
        const found = taskListArr.find((item) => customListTitles.includes(item));
        return found ?? null;
    }
}
export default FilterService;
